import React from 'react';
import PropTypes from 'prop-types';
import { Parser } from 'html-to-react';
import UserService from '../../../../../../services/user.service';
import AttachedFile from '../../../../../../components/files/attachedFile';

const htmlToComponents = new Parser().parse;


const Message = ({
  t,
  src,
  item,
  time,
  user,
  setEditMessage,
  setRemoveMessage,
}) => (
  <div className="msg_text boxs">
    <div className="left">
      <div className="msgimg msg-wrp-img">
        <img
          src={src}
          alt="message"
          className="msgImg"
          onError={e => e.target.src = UserService.defaultAvatar}
        />
      </div>
      <div className="msgTextw">
        <div className="fontmulisemi message" id={`msg-${item.id}`}>{htmlToComponents(item.content)}</div>
        {item.files && item.files.map(file => (
          <AttachedFile
            key={file.id}
            file={{ ...file, original: file.filename }}
            filenameLen={20}
            viewOnly
          />
      ))}
      </div>
    </div>
    <div className="right">
      <ul className="msgaction">
        <li className="msgactionli"><p>{time}</p></li>
        {item.created_by === user.id ? <li className="actiondiv msgactionli">
          <p><img src="/img/ecllipse.svg" alt="ecllipse" className="img-responsive" /></p>
          <div className="onactionhover boxs">
            <ul>
              <li>
                <a href="#" onClick={e => setEditMessage(e, item)}>{t('Edit')}</a>
              </li>
              <li>
                <a href="#" onClick={e => setRemoveMessage(e, item)}>{t('Remove')}</a>
              </li>
            </ul>
          </div>
        </li> : <li className="actiondiv msgactionli" /> }
      </ul>
    </div>
  </div>
);

Message.propTypes = {
  t: PropTypes.func.isRequired,
  src: PropTypes.string.isRequired,
  item: PropTypes.object.isRequired,
  time: PropTypes.string.isRequired,
};

export default Message;



// WEBPACK FOOTER //
// ./src/views/modules/messages/chat/chatBox/message/Message.jsx